export default __webpack_public_path__ + "static/media/litho-demo-hotel-resort.a4a80f8e.jpg";